<template>
  <el-header height="auto">
      <div class="hdr-tit">
        <h5 class="primary-color"> {{ userdata && userdata.client === "Bupa" ? "" : dashboardTitle }}</h5> <!--<h6>King Fahad Medical City</h6>-->
      </div>
      <el-menu class="el-menu-demo" mode="horizontal">
        <el-menu-item v-if="$store.getters['uicomponents/isEmployees'] && $store.getters['employees/userTypeName']">
            <router-link class="add-btn" tag="button" :to="{ path:'/employees/'+$store.getters['employees/userTypeName']+'/add'}">Add {{$store.getters['employees/userTypeName'] | capitalize}}</router-link>
        </el-menu-item>
          <!-- <el-menu-item class="left" v-if="$store.getters['uicomponents/isAccounts']">
            <router-link class="add-btn" tag="button" :to="{ path: '/accounts/add-bill'}">Add Bill</router-link>
          </el-menu-item> -->
        
         <!--  <el-menu-item v-if="$store.getters['masters/setemp']&&$store.getters['uicomponents/isMaster']&&$store.getters.masterTypeName&&$store.getters.actionType">
            <router-link class="add-btn" tag="button" :to="{ path: '/master/'+$store.getters.masterTypeName+'/'+$store.getters['masters/geturl']}" >
                                    {{$store.getters['masters/setemp'].employee?$store.getters['masters/setemp'].employee==4?'Add Test':$store.getters['masters/setemp'].employee==3?' Add Tasks':'Add Treatment':$store.getters['masters/geturl']}}
                               </router-link>
          </el-menu-item>
          <el-menu-item v-if="$store.getters['uicomponents/isMaster'] && $store.getters.masterTypeName =='servietype_task' &&$store.getters['masters/setemp']&&$store.getters['masters/setemp'].employee==4">
            <router-link class="add-btn2" tag="button" :to="{ path: '/master/'+$store.getters.masterTypeName+'/addPackage'}">Add a new Package</router-link>
          </el-menu-item> -->
          <!-- <el-menu-item v-if="$store.getters['uicomponents/isService']">
             <router-link class="add-btn2" tag="button" :to="{ path: '/services/'+$store.getters.serviceTypeName+'/add'}">Add {{$store.getters.serviceTypeName=='tasks'?'Task':$store.getters.serviceTypeName=='treatments'?'Treatment':$store.getters.serviceTypeName=='treatment'?'Treatment':$store.getters.serviceTypeName=='tests'?'Test':'Packages'}}</router-link>
            <router-link class="add-btn2" tag="button" :to="{ path: '/services/'+$store.getters.serviceTypeName+'/add'}">Add Price</router-link>
          </el-menu-item>  -->
          <el-menu-item v-if="$store.getters['uicomponents/isMaster']&&$store.getters.masterTypeName!='department'">
            <router-link class="add-btn2" tag="button" :to="{ path: '/master/'+$store.getters.masterTypeName+'/add'}">Add {{$store.getters.masterTypeName=='tasks'?'Task':$store.getters.masterTypeName=='treatments'?'Treatment':$store.getters.masterTypeName=='treatment'?'Treatment':$store.getters.masterTypeName=='tests'?'Test':'Packages'}}</router-link>
          </el-menu-item> 
          <el-submenu index="4" popper-class="profile-text" class="profile">
            <template slot="title">
            <span class="profile-men-cnt"><h6>{{userdata.name}}</h6> {{userdata.email}}</span>
            <img src="/static/images/user.svg" class="avtar"></template>
          <el-menu-item index="2-1" @click="changpassword()">Change Password</el-menu-item>
          <el-menu-item index="2-1" @click.native="logout()">Logout</el-menu-item>
        </el-submenu>
      </el-menu>
  </el-header>
</template>
<script>
// import { mapState } from 'vuex'
export default {
  // computed: mapState(['dashboardTitle']),
  name: "HeaderStrip",
  data() {
    return {
      userData: null,
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch("auth/LOGOUT").then(() => {
        localStorage.setItem('userdetails',null)
        this.$router.push("/login");
      });
    },
    changpassword: function() {
      this.$router.push("/change-password");
    }
  },

  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    dashboardTitle() {
      return this.$store.getters["getDashboardTitle"];
    },
    userdata() {
      return JSON.parse(localStorage.getItem("userdetails"));
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/HeaderStrip.vue